<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      justify="center"
      no-gutters
    >
      <v-col cols="12" />
      <v-col
        cols="12"
        sm="8"
        md="8"
        lg="6"
        xl="5"
      >
        <div
          style="border-radius:4px;background:white;"
          class="elevation-3"
        >
          <v-row no-gutters>
            <v-col
              class="ma-auto"
              cols="12"
              md="3"
              style="display: flex;justify-content: center;"
            > 
              <v-img
                :class="[
                  this.$vuetify.breakpoint.xs? 'mt-8':'',
                  this.$vuetify.breakpoint.sm? 'mt-8':'',
                ]"
                :max-height="logoHeight"
                :max-width="logoWidth"
                :src="changeLogo"
              />
            </v-col>

            <v-col
              cols="12"
              md="9"
              class="py-6 border-left"
            >
              <div class="text-center">
                <span 
                  v-if="isToddOrg" 
                  class="font-color font-size-40 font-calibri font-weight-medium"
                >
                  SELAT
                </span>
                <span 
                  v-else
                  class="font-color font-size-40 font-calibri font-weight-medium"
                >
                  FRANCO
                </span>
                <span class="font-color font-size-20 font-calibri">HR</span>
              </div>

              <div>
                <v-form        
                  ref="form"
                  lazy-validation
                >
                  <v-container class="py-0">
                    <v-row>
                      <v-col cols="12">
                        <v-text-field
                          v-model="username"
                          v-validate="'required'"
                          :error-messages="errors.collect('username')"
                          data-vv-name="username"   
                          :disabled="progressing"                    
                          prepend-icon="person"
                          label="Username"
                          type="text"
                          autofocus
                        />
                        <v-text-field
                          v-model="password"
                          v-validate="'required'"
                          :error-messages="errors.collect('password')"
                          data-vv-name="password"   
                          :disabled="progressing"
                          prepend-icon="lock"                      
                          label="Password"
                          type="password"
                          autocomplete="off"
                          @keydown.enter="login"
                        />                 
                      </v-col>
                      <v-col
                        class="text-right"
                        cols="12"
                      >
                        <v-btn           
                          :loading="progressing"         
                          class="font-weight-light"                    
                          color="hrissecondary"
                          dark
                          @click="login"               
                        >
                          LOGIN
                        </v-btn>
                        <v-snackbar                    
                          v-model="snackbar"
                          :color="snackbarColor"
                          :top="true"                                       
                          dark                    
                        >
                          <v-icon
                            color="white"
                            class="mr-4"
                          >
                            mdi-bell-plus
                          </v-icon>
                          <div align="left">
                            {{ errorMessages }}
                          </div>
                          <v-icon
                            size="16"
                            @click="snackbar = false"
                          >
                            mdi-close-circle
                          </v-icon>
                        </v-snackbar>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-col>
      <v-col cols="12" />
    </v-row>
  </v-container>
</template>

<script>
  import { mapActions } from 'vuex'
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        username: '',
        password: '',
        progressing: false,
        snackbar: false,
        snackbarColor: 'error',
        errorMessages: 'Please try again',
        appOrg: process.env.VUE_APP_ORG,
        isToddOrg: false,
      }
    },
    computed: {
      logoHeight () {
        if (this.$vuetify.breakpoint.md) {
          return 90 
        }

        if (this.$vuetify.breakpoint.lg) {
          return 96 
        }
        
        if (this.$vuetify.breakpoint.xl) {
          return 108 
        }

        return 120
      },
      logoWidth () {
        if (this.$vuetify.breakpoint.md) {
          return 150
        }

        if (this.$vuetify.breakpoint.lg) {
          return 160 
        }

        if (this.$vuetify.breakpoint.xl) {
          return 180 
        }

        return 200
      },
      changeLogo () {
        return this.appOrg === 'todd' ? 'img/katimas_logo.jpg' : 'img/rex_logo.png'
      },
    },
    created () {
      this.isToddOrg = this.appOrg === 'todd'
    },    
    methods: {
      ...mapActions('lookup', ['getLookups']),
      login () {
        this.$validator.validateAll()
          .then(result => {
            if (!result) return 
            this.progressing = true

            let username = this.username
            let password = this.password

            this.$store.dispatch('login', { username, password })
              .then((response) => {
                this.loadData()
                  .then(data => {          
                    this.$router.push({ path: '/profile' })
                  })
                  .catch(() => {
                    this.$manualLogout()
                  })
                  .then(() => {
                    this.progressing = false
                  })
              })
              .catch(err => {
                let response = err.response

                if ((response.data || {}).message) {
                  this.errorMessages = (response.data || {}).message
                }

                this.snackbar = true
                this.progressing = false
              })
          })
      },
      loadData () {
        let username = this.username

        return this.$http.all([
          this.$store.dispatch('getCurrentUser'),
          this.$store.dispatch('getUserPermissions'),
          this.$store.dispatch('updateUserLastLogin', { username }),
          this.$store.dispatch('getCompanyOrganization'),
          this.getLookups('title'),
          this.getLookups('gender'),
          this.getLookups('ethnicity'),
          this.getLookups('religion'),
          this.getLookups('marital_status'),
          this.getLookups('place_of_birth'),
          this.getLookups('citizenship'),
          this.getLookups('claim_unit_of_measurement'),
        ])
      },
    },
  }
</script>

<style scoped>
.font-color{
  color:#3796CF;
}
.font-size-40{
  font-size: 40px;
}
.font-size-20{
  font-size: 20px;
}
.font-calibri{
  font-family: calibri;
}
.border-left{
  border-left:1px solid #e5e5e5;
}

</style>
